export const enum RepeatValues {
  EVERYDAY = 'Everyday',
  WEEKDAY = 'Every weekday (Monday to Friday)',
  CUSTOM = 'Custom/rotational',
}
export const enum RepeatByValues {
  WEEK = 'Week',
  MONTH = 'Month',
}

export const enum FormIDs {
  MENU_SCHEDULE_FORM = 'menu-schedule-form',
  MENU_SCHEDULE_FORM_REPEAT = 'menu-schedule-form-repeat',
}

export const enum PriceLevels {
  DEFAULT_PRICE_LEVEL = 'default_price_level',
}
